import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import { ServicioComplementario } from "app/main/apps/shared/models/servicio-complementario.model";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { MatSelectChange } from "@angular/material/select";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";

@Component({
    selector: "app-dialog-agregar-servicio-complementario",
    templateUrl: "./dialog-agregar-servicio-complementario.component.html",
    styleUrls: ["./dialog-agregar-servicio-complementario.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogAgregarServicioComplementarioComponent implements OnInit {
    formAgregarServicioComp: FormGroup;
    largoMaximo = 500;
    @ViewChild("fileInput", { static: true })
    file: File = null;
    constructor(
        public dialogRef: MatDialogRef<DialogAgregarServicioComplementarioComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            servicioComplementario: ServicioComplementario;
            editar: boolean;
            archivo: File;
            sucursales: SucursalPersonaDTO[];
        },
        private fb: FormBuilder,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _notificacionSrvc: NotificacionesService
    ) {}

    ngOnInit(): void {
        //console.log(this.data);
        this.initForm();
    }

    initForm() {
        this.formAgregarServicioComp = this.fb.group({
            sucursal: [
                this.data.servicioComplementario?.sucursal || null,
                { validators: [Validators.required] },
            ],
            observacion: [
                this.data.servicioComplementario?.observacion || "",
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(10),
                        Validators.maxLength(this.largoMaximo),
                    ],
                },
            ],
            archivo: [this.data.archivo?.name || null],
        });
    }

    get sucursal() {
        return this.formAgregarServicioComp.get("sucursal");
    }
    get observacion() {
        return this.formAgregarServicioComp.get("observacion");
    }

    get archivo() {
        return this.formAgregarServicioComp.get("archivo");
    }

    puedeCotizar(event: MatSelectChange) {
        const puedeCotizar = this._menuUsuarioSrvc.puedeRealizarAccion(
            event.value,
            "puedeCotizar"
        );
        if (!puedeCotizar) {
            this.sucursal.setValue(null);
            this._notificacionSrvc.mostrarNotificacion(
                `No esta autorizado para cotizar en esta sucursal, favor contacte a su representante`,
                "error"
            );
        }
    }

    getFile(event) {
        const file = event && event.item(0);
        this.file = file;
    }

    guardar() {
        const data = {
            form: this.formAgregarServicioComp.value,
            archivo: this.file instanceof File ? this.file : null,
        };

        this.dialogRef.close(data);
    }
    cerrar(): void {
        this.dialogRef.close();
    }
}
